export const firebaseConfig = {
  apiKey: "AIzaSyDPTys1ze7PTZY1SCRaYH0vYDwtlO6Ed48",
  authDomain: "itpo-1407f.firebaseapp.com",
  projectId: "itpo-1407f",
  storageBucket: "itpo-1407f.appspot.com",
  messagingSenderId: "361130063251",
  appId: "1:361130063251:web:1830b5cec4545275f3a466",
  measurementId: "G-LGYR8MVZZK",
};
